<template>
  <div>
    <a-card v-if="queryList" :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="12">
            <a-col :md="6" :sm="24">
              <a-form-item label="订单号">
                <a-input v-model="queryParam.orderNo" />
              </a-form-item>
            </a-col>
            <span v-if="userType != '22'">
              <a-col :md="5" :sm="24">
                <a-form-item label="客户姓名">
                  <a-input v-model="queryParam.clientName" />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="客户联系方式">
                  <a-input v-model="queryParam.clientPhone" />
                </a-form-item>
              </a-col>
            </span>
            <a-col :md="6" :sm="24" v-if="userType == '22'">
              <a-form-item label="客户信息">
                <a-input
                  autocomplete="off"
                  placeholder="客户手机号/客户姓名"
                  v-model.trim="queryParam.clientNameOrTel"
                />
              </a-form-item>
            </a-col>
            <a-col :md="4" :sm="24">
              <a-form-item label="处理情况">
                <a-select :allowClear="true" v-model="queryParam.handleStatus">
                  <a-select-option value="0" title="待处理"> 待处理 </a-select-option>
                  <a-select-option value="1" title="处理中"> 处理中 </a-select-option>
                  <a-select-option value="2" title="待确认"> 待确认 </a-select-option>
                  <a-select-option value="3" title="结束"> 结束 </a-select-option>
                  <a-select-option value="9" title="撤单"> 撤单 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col v-if="userType == '22'">
              <a-col v-if="complainTime" :md="2" :sm="24">
                <a-select v-model="queryParam.timeType" :allowClear="true">
                  <a-select-option value="0" title="投诉时间"> 投诉时间 </a-select-option>
                  <a-select-option value="1" title="开始处理时间"> 开始处理时间 </a-select-option>
                  <a-select-option value="2" title="处理完成时间"> 处理完成时间 </a-select-option>
                  <a-select-option value="3" title="建单时间"> 建单时间 </a-select-option>
                </a-select>
              </a-col>
              <a-col v-else :md="2">
                <a-select style="width: 100%" v-model="queryParam.timeType" :allowClear="true">
                  <a-select-option value="0" title="投诉时间"> 投诉时间 </a-select-option>
                  <a-select-option value="3" title="建单时间"> 建单时间 </a-select-option>
                </a-select>
              </a-col>
              <a-col :md="5" :sm="12">
                <a-range-picker
                  style="width: 100%"
                  v-model="dateString"
                  :show-time="{
                    hideDisabledOptions: true,
                    defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                  }"
                  format="YYYY-MM-DD HH:mm:ss"
                  :placeholder="['开始时间', '结束时间']"
                  @change="onChangerangepicker"
                />
              </a-col>
            </a-col>
          </a-row>
          <a-row :gutter="24" v-if="userType != '22'">
            <a-col v-if="complainTime" :md="4" :sm="24">
              <a-select style="margin-left: 39px; width: 100%" v-model="queryParam.timeType" :allowClear="true">
                <a-select-option value="0" title="投诉时间"> 投诉时间 </a-select-option>
                <a-select-option value="1" title="开始处理时间"> 开始处理时间 </a-select-option>
                <a-select-option value="2" title="处理完成时间"> 处理完成时间 </a-select-option>
                <a-select-option value="3" title="建单时间"> 建单时间 </a-select-option>
              </a-select>
            </a-col>
            <a-col v-else :md="4">
              <a-select style="margin-left: 39px; width: 100%" v-model="queryParam.timeType" :allowClear="true">
                <a-select-option value="0" title="投诉时间"> 投诉时间 </a-select-option>
                <a-select-option value="3" title="建单时间"> 建单时间 </a-select-option>
              </a-select>
            </a-col>
            <a-col :md="7" :sm="12">
              <a-range-picker
                style="width: 100%; margin-left: 39px"
                v-model="dateString"
                :show-time="{
                  hideDisabledOptions: true,
                  defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')],
                }"
                format="YYYY-MM-DD HH:mm:ss"
                :placeholder="['开始时间', '结束时间']"
                @change="onChangerangepicker"
              />
            </a-col>
            <a-col :md="10" :sm="12">
              <a-form-item label="企业名称" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 30px">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  :filterOption="filterOption"
                  v-model="queryParam.enterpriseName"
                  :allowClear="true"
                >
                  <a-select-option v-for="type in selectCombox" :title="type.enterpriseName" :key="type.enterpriseId"
                    >{{ type.enterpriseName }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24" v-if="userType != '22'">
            <a-col :md="6" :sm="24" v-if="userType != '22'">
              <a-form-item label="安装类别" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.installType" @change="installChange" :allowClear="true">
                  <a-select-option v-for="type in installTypes" :title="type.dictLabel" :key="type.dictValue">{{
                    type.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="userType != '22'">
              <a-form-item label="订单类型" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.orderType" :allowClear="true" @change="getorderStatus">
                  <a-select-option v-for="type in List" :title="type.typeName" :key="type.orderTypeId">{{
                    type.typeName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24" v-if="userType != '22'">
              <a-row :gutter="24" style="margin-left: 0px" v-if="userType != '22'">
                <a-form-item label="客户地址" style="margin-left: 26px">
                  <a-col :md="5" :sm="24">
                    <a-select v-model="queryParam.province" @change="getselect" :allowClear="true">
                      <a-select-option
                        v-for="type in selectAllProvince"
                        :title="type.provinceName"
                        :key="type.provinceCode"
                        >{{ type.provinceName }}</a-select-option
                      >
                    </a-select>
                  </a-col>
                  <a-col :md="5" :sm="24">
                    <a-select v-model="queryParam.city" @change="getprovinceName" :allowClear="true">
                      <a-select-option v-for="type in selectCityName" :title="type.cityName" :key="type.cityCode">{{
                        type.cityName
                      }}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="5" :sm="24">
                    <a-select v-model="queryParam.area" :allowClear="true">
                      <a-select-option v-for="type in selectAreaName" :title="type.areaName" :key="type.areaCode">{{
                        type.areaName
                      }}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="9" :sm="24">
                    <a-input v-model="queryParam.clientAddress" />
                  </a-col>
                </a-form-item>
              </a-row>
            </a-col>
          </a-row>
          <a-row :gutter="24" v-if="userType != '22'">
            <a-col :md="6" :sm="24" v-if="userType != '22'">
              <a-form-item label="师傅姓名" style="margin-left: 26px">
                <a-input v-model="queryParam.masterName" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24" v-if="userType != '22'">
              <a-form-item label="师傅联系方式">
                <a-input v-model="queryParam.masterPhone" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单状态" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.orderStatus" :allowClear="true">
                  <a-select-option v-for="type in order_status" :title="type.dictLabel" :key="type.dictValue">{{
                    type.dictLabel
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单负责人">
                <a-select v-model="queryParam.orderPrincipal">
                  <a-select-option v-for="type in findByDeptId" :title="type.userName" :key="type.userId">{{
                    type.userName
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24" v-if="userType != '22'">
            <a-col :md="6" :sm="24">
              <a-form-item label="投诉类型" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                <a-select v-model="queryParam.complaintType" :allowClear="true">
                  <a-select-option v-for="type in pendingMatterMenu" :title="type.name" :key="type.code">{{
                    type.name
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="投诉内容" style="margin-left: 30px">
                <a-input v-model="queryParam.complaintContents" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="投诉人" style="margin-left: 39px">
                <a-input v-model="queryParam.complainter" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="投诉对象" style="margin-left: 30px">
                <a-input v-model="queryParam.complaintPersonId" />
              </a-form-item>
            </a-col>
          </a-row>
          <div v-if="Ifstatus && userType != '22'">
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="处理人" style="margin-left: 45px">
                  <a-input v-model="queryParam.handler" />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="当前协助人" style="margin-left: 13px">
                  <a-input v-model="queryParam.assistingPeople" />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-row :gutter="24">
                  <a-form-item label="处理时长" style="margin-left: 42px">
                    <a-col :span="6">
                      <a-input placeholder="最小值" v-model="queryParam.handleStartTime" />
                    </a-col>
                    <a-col :span="1" style="display: flex; justify-content: center"> - </a-col>
                    <a-col :span="6">
                      <a-input placeholder="最大值" v-model="queryParam.handleEndTime" />
                    </a-col>
                    <a-col :md="10" :sm="24">
                      <a-select default-value="h" :allowClear="true" v-model="queryParam.handleTimeType">
                        <a-select-option value="h" title="小时"> 小时 </a-select-option>
                        <a-select-option value="d" title="天"> 天 </a-select-option>
                        <a-select-option value="m" title="分钟"> 分钟 </a-select-option>
                      </a-select>
                    </a-col>
                  </a-form-item>
                </a-row>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-row :gutter="24">
                  <a-form-item label="总处理时长" style="margin-left: 24px">
                    <a-col :span="6">
                      <a-input placeholder="最小值" v-model="queryParam.sumHandleStartTime" />
                    </a-col>
                    <a-col :span="1" style="display: flex; justify-content: center"> - </a-col>
                    <a-col :span="6">
                      <a-input placeholder="最大值" v-model="queryParam.sumHandleEndTime" />
                    </a-col>
                    <a-col :md="10" :sm="24">
                      <a-select default-value="h" :allowClear="true" v-model="queryParam.sumHandleTimeType">
                        <a-select-option value="h" title="小时"> 小时 </a-select-option>
                        <a-select-option value="d" title="天"> 天 </a-select-option>
                        <a-select-option value="m" title="分钟"> 分钟 </a-select-option>
                      </a-select>
                    </a-col>
                  </a-form-item>
                </a-row>
              </a-col>
            </a-row>
          </div>
          <a-row :gutter="24">
            <a-col :span="1" :offset="11" v-if="userType != '22'" style="margin-top: 24px">
              <span v-if="Ifstatus == 0" style="cursor: pointer" @click="getMore"
                ><a-icon type="down-circle" theme="twoTone" style="fontsize: 24px"
              /></span>
              <span v-if="Ifstatus == 1" style="cursor: pointer" @click="hiddenMore"
                ><a-icon type="up-circle" theme="twoTone" style="fontsize: 24px"
              /></span>
            </a-col>
            <a-col :span="12" :style="{ textAlign: 'right' }" :offset="10">
              <a-button type="primary" htmlType="submit" @click="$refs.table.refresh(true)" v-if="userType != '22'"
                >查询</a-button
              >
              <a-button type="primary" htmlType="submit" @click="$refs.table1.refresh(true)" v-if="userType == '22'"
                >查询</a-button
              >
              <a-button style="margin-left: 8px" @click="empty()">清空</a-button>
              <a-button style="margin-left: 8px" type="primary" v-if="feedbackexport" @click="exceptExcel"
                >导出 Excel</a-button
              >
            </a-col>
          </a-row>
          <a-divider />
          <div class="table-operator"></div>
          <!--    表格内容-->
          <s-table
            size="default"
            ref="table"
            :columns="columns"
            :data="loadData"
            bordered
            :scroll="{ x: 4500 }"
            v-if="userType != '22'"
          >
            <span slot="action" slot-scope="text, record" style="white-space: nowrap">
              <a-tag color="blue" v-if="details" @click="detailsView(record)">查看 </a-tag>
              <a-tag color="cyan" v-if="record.identification != 1 && manage" @click="problemsDealing(record)"
                >处理</a-tag
              >
              <a-tag
                color="red"
                v-if="dispatcher && (record.handleStatus == '处理中' || record.handleStatus == '待处理')"
                @click="problemsTransfer(record)"
                >转派</a-tag
              >
              <a-tag color="orange" v-if="questionList" @click="resume(record)">履历</a-tag>
            </span>
          </s-table>
          <s-table size="default" ref="table1" :columns="columns1" :data="loadData" bordered v-if="userType == '22'">
            <span slot="action" slot-scope="text, record" style="white-space: nowrap">
              <a-tag color="blue" v-if="details" @click="detailsView(record)">查看</a-tag>
            </span>
            <span slot="complaintContents" slot-scope="text, record">
              <div style="width: 100px; text-overflow: ellipsis; overflow: hidden; margin-left: 35%">
                {{ record.complaintContents }}
              </div>
            </span>
          </s-table>
        </a-form>
      </div>
      <a-modal v-model="transferible" @ok="addtransfer()" title="转派" :width="600">
        <a-form :form="transferform">
          <a-row>
            <a-col>
              <a-form-item style="display: none">
                <a-input v-decorator="['complaintsHeaderId']" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="转派角色">
                <a-select
                  showSearch
                  optionFilterProp="children"
                  @change="onChangecomplaint"
                  :filterOption="filterOption"
                  style="width: 300px"
                  v-decorator="['roleCode', { rules: [{ required: true, message: '请选择转派角色!' }] }]"
                >
                  <a-select-option v-for="type in pendingMattersRoleList" :key="type.code"
                    >{{ type.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-modal>
      <a-modal v-model="dealingible" title="处理" :width="600" footer="">
        <a-form :form="dealingform">
          <a-row>
            <a-col>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="投诉类型">
                {{ this.feedbackInfo.matterName }}
              </a-form-item>
              <div v-for="(tab, index) in feedbackInfo.itemInfos" :key="index">
                <div v-if="tab.type == 1">
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="投诉内容">
                    {{ tab.contents }}
                  </a-form-item>
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="附件">
                    <a-upload
                      :action="uploadUrlb"
                      listType="picture-card"
                      :fileList="tab.arrList"
                      :headers="headers"
                      @preview="handlePreview"
                    >
                    </a-upload>
                  </a-form-item>
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="申诉人">
                    <div>{{ tab.createName }}</div>
                  </a-form-item>
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="申请时间">
                    <div>{{ tab.createTime }}</div>
                  </a-form-item>
                </div>
                <div v-if="tab.type == 1" style="border: 1px solid #ccc"></div>
                <div v-if="tab.type == 2">
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="处理回复">
                    {{ tab.contents }}
                  </a-form-item>
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="附件">
                    <a-upload
                      :action="uploadUrlb"
                      listType="picture-card"
                      :fileList="tab.arrList"
                      :headers="headers"
                      @preview="handlePreview"
                    >
                    </a-upload>
                  </a-form-item>
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="处理人">
                    <span> {{ tab.createName }}</span>
                    <span style="margin-left: 25px">申请时间: {{ tab.createTime }}</span>
                  </a-form-item>
                  <div v-if="tab.type == 2" style="border: 1px solid #ccc"></div>
                </div>
                <div></div>
              </div>
              <a-form :form="replyproblemsform">
                <div v-if="startProcessingible" style="margin: 20px">
                  <a-form-item style="display: none">
                    <a-input v-decorator="['complaintsHeaderId']" />
                  </a-form-item>
                  <a-form-item style="display: none">
                    <a-input v-decorator="['complaintObject']" />
                  </a-form-item>
                  <a-form-item style="display: none">
                    <a-input v-decorator="['respondent']" />
                  </a-form-item>
                  <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    :label="appealProcessingible ? '申诉内容' : '处理回复'"
                  >
                    <a-input
                      v-decorator="['contents', { rules: [{ required: true, message: '请填写内容!' }] }]"
                      type="textarea"
                    />
                  </a-form-item>
                  <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上传文件">
                    <a-upload
                      name="file"
                      :multiple="true"
                      :action="currencyuploadUrl"
                      list-type="picture-card"
                      class="avatar-uploader"
                      :file-list="dealinglist"
                      :headers="headers"
                      @change="dealingChange"
                      @preview="handlePreview"
                    >
                      <a-icon type="upload" />
                      <div class="ant-upload-text">图片</div>
                    </a-upload>
                  </a-form-item>
                </div>
              </a-form>
              <div style="text-align: center">
                <a-button
                  type="primary"
                  style="margin: 20px"
                  @click="updateFeedback"
                  v-if="!feedbackInfo.handleStartTime && !detailsViewible"
                  >修改</a-button
                >
                <a-button
                  type="primary"
                  style="margin: 20px"
                  @click="revoke"
                  v-if="!feedbackInfo.handleStartTime && !detailsViewible"
                  >撤回
                </a-button>
                <a-button
                  type="primary"
                  style="margin: 20px"
                  @click="startProcessing"
                  v-if="!startProcessingible && !processingCompletedible && !appealProcessingible && !detailsViewible"
                  >处理</a-button
                >
              </div>
              <div style="text-align: center" v-if="startProcessingible && !appealProcessingible">
                <a-button type="primary" style="margin: 20px" @click="problemsTransfer(feedbackInfo)">转派 </a-button>
                <a-button type="primary" style="margin: 20px" @click="replyproblems">回复</a-button>
                <a-button type="primary" style="margin: 20px" @click="processingCompleted">处理完成 </a-button>
              </div>
              <div style="text-align: center" v-if="processingCompletedible && !startProcessingible">
                <a-button type="primary" style="margin: 20px" @click="endProcessing">接受处理意见 </a-button>
                <a-button type="primary" style="margin: 20px" @click="appealProcessing">申诉</a-button>
              </div>
              <div style="text-align: center" v-if="appealProcessingible">
                <a-button type="primary" style="margin: 20px" @click="appealProcessingsubmit">提交 </a-button>
                <a-button type="primary" style="margin: 20px" @click="appealProcessingcancel">取消</a-button>
              </div>
            </a-col>
          </a-row>
        </a-form>
      </a-modal>
      <a-modal v-model="resumeible" title="履历" :width="600" footer="">
        <a-form :form="resumeform">
          <a-row v-for="(tab, index) in pendingMattersResume" :key="index">
            <a-col>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="问题内容">
                {{ tab.content }}
                <!--<a-input v-model="" type="textarea" disabled="disabled"/>-->
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="申请人">
                {{ tab.createName }}
                <!--<a-input v-model="tab.createName" disabled="disabled" />-->
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="申请时间">
                {{ tab.createTime }}
                <!--<a-input v-model="tab.createTime"  disabled="disabled" />-->
              </a-form-item>
              <div v-if="index != pendingMattersResume.length - 1" style="border: 1px solid #ccc"></div>
            </a-col>
          </a-row>
        </a-form>
      </a-modal>
      <a-modal v-model="updateproblemible" @ok="updateproblem()" title="修改" :width="600">
        <a-form :form="updateproblemform">
          <a-row>
            <a-col>
              <a-form-item style="display: none">
                <a-input v-decorator="['complaintsHeaderId']" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="投诉类型">
                <a-input v-decorator="['matterName']" disabled="disabled" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="投诉内容">
                <a-input
                  v-decorator="['contents', { rules: [{ required: true, message: '请填写内容!' }] }]"
                  type="textarea"
                />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上传文件">
                <a-upload
                  name="file"
                  :multiple="true"
                  :action="currencyuploadUrl"
                  list-type="picture-card"
                  class="avatar-uploader"
                  :file-list="updatepiclist"
                  :headers="headers"
                  @change="updatehandleChange"
                  @preview="handlePreview"
                >
                  <a-icon type="upload" />
                  <div class="ant-upload-text">图片</div>
                </a-upload>
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="申请人">
                <a-input v-decorator="['complainantName']" disabled="disabled" />
              </a-form-item>
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="申请时间">
                <a-input v-decorator="['handleStartTime']" disabled="disabled" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-modal>
      <a-modal title="撤回" v-model="deleteible" @ok="deleteOK">
        <p>此操作将确认撤回投诉，是否继续？</p>
      </a-modal>
      <a-modal :visible="previewVisible" :footer="null" @cancel="previewhandleCancel">
        <img alt="example" style="width: 100%; padding: 10px" :src="previewImage" />
      </a-modal>
    </a-card>
    <no-authority v-else></no-authority>
  </div>
</template>

<script>
import moment from 'moment'
import { checkPermission } from '@/utils/permissions'
import {
  getselectAllProvince,
  getselectCityName,
  getselectAreaName,
  getList,
  getOrderDetail,
  getfinddictAll,
  getfindByDeptId,
} from '@/api/order/orderList'
import { getselectCombox } from '@/api/order/NewlyaddedOrderList'
import {
  getreply,
  getappeal,
  getendProcessing,
  getprocessingCompleted,
  startProcessing,
  updateComplaint,
  getComplaintInfo2,
  getPendingMattersResume,
  revoke,
  selectComplaint,
  selectAllProvince,
  selectCityName,
  getPendingMatterMenu,
  getComplaintInfo,
  transfer,
  getPendingMattersRoleList,
  exportcomplaintOrder,
} from '@/api/compalanit/compalanit'
import { getDictMap } from '../../utils/dict'
import { STable } from '@/components'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import NoAuthority from '../enterprise/NoAuthority'
import pick from 'lodash.pick'

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = (error) => reject(error)
  })
}
export default {
  name: 'PartsOrder',
  components: {
    STable,
    NoAuthority,
    // 注册弹框组件
  },
  data() {
    return {
      arrList: [],
      updatepiclist: [],
      previewVisible: false,
      Ifstatus: 0,
      dateString: '',
      previewImage: '',
      previewimgible: false,
      previewimgurl: '',
      token: Vue.ls.get(ACCESS_TOKEN),
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN),
      },
      currencyuploadUrl: process.env.VUE_APP_API_BASE_URL + '/dfs/upload?type=feedback',
      process: process.env.VUE_APP_API_BASE_URL + '/dfs/download',
      // 查看投诉详情
      details: checkPermission('complainDetails'),
      // 处理
      manage: checkPermission('complaint:manage'),
      // 转派
      dispatcher: checkPermission('complaint:dispatcher'),
      // 投诉履历
      questionList: checkPermission('complainRecord'),
      // 导出列表
      feedbackexport: checkPermission('complaint:export:order'),
      queryList: checkPermission('order:complaints:query:list'),
      complainTime: checkPermission('complainTime'),
      findByDeptId: [],
      order_substate: [],
      defaultFileList: [],
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: 'id',
          align: 'center',
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
        },
        {
          title: '处理情况',
          dataIndex: 'handleStatus',
          align: 'center',
        },
        {
          title: '投诉类型',
          dataIndex: 'matterName',
          align: 'center',
        },
        {
          title: '投诉内容',
          dataIndex: 'complaintContents',
        },
        {
          title: '状态栏',
          dataIndex: 'statusArea',
          align: 'center',
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          align: 'center',
        },
        {
          title: '企业名称',
          dataIndex: 'enterpriseInfo.enterpriseName',
          align: 'center',
        },
        {
          title: '市场负责人',
          dataIndex: 'marketPrincipal',
          align: 'center',
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus',
          align: 'center',
        },
        {
          title: '订单子状态',
          dataIndex: 'substate',
          scopedSlots: { customRender: 'substate' },
          align: 'center',
        },
        {
          title: '投诉人',
          dataIndex: 'complainter',
          scopedSlots: { customRender: 'complainter' },
          align: 'center',
        },
        {
          title: '投诉人电话',
          dataIndex: 'complaintPhone',
          align: 'center',
        },
        {
          title: '投诉对象',
          dataIndex: 'complaintPerson',
          align: 'center',
        },
        {
          title: '投诉申请时间',
          dataIndex: 'complaintTime',
          align: 'center',
        },
        {
          title: '安装类型',
          dataIndex: 'installType',
          scopedSlots: { customRender: 'installType' },
          align: 'center',
        },
        {
          title: '订单类型',
          dataIndex: 'orderType',
          scopedSlots: { customRender: 'orderType' },
          align: 'center',
        },
        {
          title: '客户姓名',
          dataIndex: 'clientName',
          align: 'center',
        },
        {
          title: '客户电话',
          dataIndex: 'clientPhone',
          align: 'center',
        },
        {
          title: '客户地址',
          dataIndex: 'clientAddress',
          width: '300px',
        },
        {
          title: '订单负责人',
          dataIndex: 'orderPrincipal',
        },
        {
          title: '当前协助人',
          dataIndex: 'assistingPeople',
          align: 'center',
        },
        {
          title: '师傅姓名',
          dataIndex: 'masterName',
          align: 'center',
        },
        {
          title: '师傅联系方式',
          dataIndex: 'masterPhone',
          align: 'center',
        },
        {
          title: '师傅负责人',
          dataIndex: 'masterPrincipal',
          align: 'center',
        },
        {
          title: '当前处理人',
          dataIndex: 'deal',
          align: 'center',
        },
        {
          title: '建单时间',
          dataIndex: 'createTime',
          align: 'center',
        },
        {
          title: '建单人',
          dataIndex: 'createBy',
          align: 'center',
        },
        {
          title: '开始处理时间',
          dataIndex: 'dealStartTime',
          align: 'center',
        },
        {
          title: '处理完成时间',
          dataIndex: 'handle',
          align: 'center',
        },
        {
          title: '总处理时长',
          dataIndex: 'collectDealLongTime',
          align: 'center',
        },
      ],
      columns1: [
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center',
        },
        {
          title: '订单号',
          dataIndex: 'orderNo',
          align: 'center',
        },
        {
          title: '处理情况',
          dataIndex: 'handleStatus',
          align: 'center',
        },
        {
          title: '投诉类型',
          dataIndex: 'matterName',
          align: 'center',
        },
        {
          title: '投诉内容',
          dataIndex: 'complaintContents',
          align: 'center',
          scopedSlots: { customRender: 'complaintContents' },
        },
      ],
      loadData: (parameter) => {
        return selectComplaint(Object.assign(parameter, this.queryParam))
      },
      // 省
      selectAllProvince: [],
      // 市
      selectCityName: [],
      // 区
      selectAreaName: [],
      dtoList: [],
      // 字典为订单状态,
      order_status: [],
      // 字典为安装类型
      installTypes: [],
      List: [],
      // 企业名称
      selectCombox: [],
      getselectstoreList: [],
      dtoListtab: {},
      queryParam: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      pendingMatterMenu: [],
      transferible: false,
      transferform: this.$form.createForm(this),
      dealingform: this.$form.createForm(this),
      resumeform: this.$form.createForm(this),
      updateproblemform: this.$form.createForm(this),
      replyproblemsform: this.$form.createForm(this),
      // 转派 表格
      ransfertrecord: '',
      pendingMattersRoleList: [],
      feedbackInfo: '',
      dealingible: false,
      updateproblemible: false,
      resumeible: false,
      deleteible: false,
      startProcessingible: false,
      processingCompletedible: false,
      appealProcessingible: false,
      detailsViewible: false,
      pendingMattersResume: [],
      dealinglist: [],
      userType: this.$store.getters.userType,
    }
  },

  async created() {
    if (!this.complainTime) {
      var newarry = []
      var titlearry = ['总处理时长', '开始处理时间', '处理完成时间']
      for (const i in this.columns) {
        if (titlearry.indexOf(this.columns[i].title) == -1) {
          newarry.push(this.columns[i])
        }
      }
      this.columns = newarry
    }
    const dictTypes = ['install_type', 'order_status', 'order_substate']
    getfinddictAll({ dictTypes: dictTypes.join() }).then((res) => {
      this.installTypes = res.install_type
      this.order_status = res.order_status
      this.order_substate = res.order_substate
    })
    await getPendingMatterMenu({ matterTypeCode: 'complaints' }).then((res) => {
      if (res.code === 0) {
        this.pendingMatterMenu = res.data
      } else {
        this.$message.error(res.msg)
      }
    })

    // 企业名称
    this.selectCombox = []
    // isAuthority 1   数据隔离
    await getselectCombox({ isAuthority: 1 }).then((res) => {
      if (res.code === 0) {
        this.selectCombox = res.data
        // console.log(this.selectCombox)
      } else {
        this.$message.error(res.msg)
      }
    })

    await getselectAllProvince().then((res) => {
      if (res.code === 0) {
        // console.log(res)
        this.selectAllProvince = res.rows
      } else {
        this.$message.error(res.msg)
      }
    })
    // 订单负责人
    this.findByDeptId = []
    await getfindByDeptId().then((res) => {
      this.findByDeptId = res
    })
  },
  methods: {
    empty() {
      this.queryParam = {}
      ;(this.dateString = ''), console.log(this.userType)
    },
    moment,
    getorderStatus(val) {
      if (val) {
        this.$set(this.queryParam, this.queryParam.orderType, val.value)
      } else {
        this.$set(this.queryParam, this.queryParam.orderType, '')
      }
    },
    updatehandleChange(info) {
      const isJpgOrPng = info.file.type === 'image/jpeg' || info.file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('只能上传图片')
      } else {
        this.updatepiclist = info.fileList
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name}上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
      }
    },
    dealingChange(info) {
      const isJpgOrPng = info.file.type === 'image/jpeg' || info.file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('只能上传图片!')
      } else {
        this.dealinglist = info.fileList
      }

      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name}上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 上传失败.`)
      }
    },
    async handlePreview(file) {
      this.previewImage =
        process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
      this.previewVisible = true
    },

    previewhandleCancel() {
      this.previewVisible = false
    },
    exceptExcel() {
      var str = process.env.VUE_APP_API_BASE_URL + '/order/complaint/excelList?pageNum=1&pageSize=10'
      for (const i in this.queryParam) {
        if (this.queryParam[i] != undefined) {
          str = str + '&' + i + '=' + this.queryParam[i]
        }
      }
      str = str + '&token=' + this.headers.token
      window.open(str)
    },
    filterOption(input, option) {
      if (option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    },
    // 申诉
    appealProcessing() {
      this.dealinglist = []
      this.appealProcessingible = true
      this.startProcessingible = true
      setTimeout(() => {
        this.replyproblemsform.setFieldsValue(
          pick(this.feedbackInfo, 'complaintsHeaderId', 'complaintObject', 'respondent')
        )
      }, 100)
    },
    // 取消申诉
    appealProcessingcancel() {
      this.startProcessingible = false
      this.appealProcessingible = false
      this.processingCompletedible = true
    },
    // 更多、隐藏
    getMore() {
      this.Ifstatus = 1
    },
    hiddenMore() {
      this.Ifstatus = 0
    },
    // 申诉确定
    appealProcessingsubmit() {
      this.replyproblemsform.validateFields((err, values) => {
        values.headerId = values.complaintsHeaderId
        const arr = []
        this.dealinglist.forEach((tab) => {
          if (tab.response) {
            if (tab.response.code == 0) {
              const obj = {}
              obj.url = tab.response.url
              obj.uid = tab.uid
              obj.name = tab.name
              tab = obj
            }
          }
          arr.push(JSON.stringify(tab))
          console.log(arr)
        })
        values.picUrlList = arr
        if (!err) {
          getappeal(values).then((res) => {
            console.log(res)
            if (res.code === 0) {
              this.$message.success(res.msg)
              this.replyproblemsform.setFieldsValue({
                contents: '',
              })
              this.dealinglist = []
              this.$message.success(res.msg)
              this.$refs.table.refresh()
              this.appealProcessingible = false
              this.startProcessingible = true
              this.interfaceReset(this.feedbackInfo.complaintsHeaderId)
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    interfaceReset(id) {
      // getComplaintInfo2
      getComplaintInfo2({ complaintsHeaderId: id }).then((res) => {
        let arr = {}
        const that = this
        if (res.code === 0) {
          //
          this.feedbackInfo = res.data
          this.feedbackInfo.itemInfos.forEach((item) => {
            item.arrList = []
            if (item.pics) {
              item.pics.forEach((tab) => {
                // console.log(tab.indexOf('http'))
                // console.log(tab)
                if (tab.indexOf('http') != -1) {
                  item.arrList.push({
                    uid: tab,
                    url: tab,
                    status: 'done',
                  })
                } else if (tab.indexOf(':') == -1) {
                  that.getImgToBase64(
                    process.env.VUE_APP_API_BASE_URL +
                      '/dfs/download?fileName=' +
                      tab +
                      '&token=' +
                      Vue.ls.get(ACCESS_TOKEN),
                    function (data) {
                      item.arrList.push({
                        uid: tab,
                        thumbUrl: data,
                        url: tab,
                        status: 'done',
                      })
                    }
                  )
                } else {
                  arr = JSON.parse(tab)
                  that.getImgToBase64(
                    process.env.VUE_APP_API_BASE_URL +
                      '/dfs/download?fileName=' +
                      arr.url +
                      '&token=' +
                      Vue.ls.get(ACCESS_TOKEN),
                    function (data) {
                      item.arrList.push({
                        uid: arr.uid,
                        thumbUrl: data,
                        url: arr.url,
                      })
                      // console.log(item.arrList)
                    }
                  )
                }
              })
            }
          })
          this.dealingible = true
          setTimeout(() => {
            this.replyproblemsform.setFieldsValue(
              pick(this.feedbackInfo, 'complaintsHeaderId', 'complaintObject', 'respondent')
            )
          }, 100)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 开始处理
    startProcessing() {
      console.log(this.feedbackInfo, this.feedbackInfo.complaintsHeaderId)
      startProcessing({ complaintsHeaderId: this.feedbackInfo.complaintsHeaderId }).then((res) => {
        if (res.code === 0) {
          this.startProcessingible = true
          this.detailsViewible = true
          this.$refs.table.refresh()
          setTimeout(() => {
            this.replyproblemsform.setFieldsValue(
              pick(this.feedbackInfo, 'complaintsHeaderId', 'complaintObject', 'respondent')
            )
          }, 100)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 回复
    replyproblems() {
      this.startProcessing()
      this.replyproblemsform.validateFields((err, values) => {
        console.log(values)
        const arr = []
        this.dealinglist.forEach((tab) => {
          if (tab.response) {
            if (tab.response.code == 0) {
              const obj = {}
              obj.url = tab.response.url
              obj.uid = tab.uid
              obj.name = tab.name
              tab = obj
            }
          }
          arr.push(JSON.stringify(tab))
        })
        values.picUrlList = arr
        if (!err) {
          getreply(values).then((res) => {
            if (res.code === 0) {
              this.$message.success(res.msg)
              this.$refs.table.refresh()
              this.replyproblemsform.setFieldsValue({
                contents: '',
              })
              this.dealinglist = []
              this.startProcessing()
              this.interfaceReset(this.feedbackInfo.complaintsHeaderId)
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    // 处理完成
    processingCompleted() {
      getprocessingCompleted({ complaintsHeaderId: this.feedbackInfo.complaintsHeaderId }).then((res) => {
        if (res.code === 0) {
          this.$refs.table.refresh()
          this.startProcessingible = false
          this.processingCompletedible = true
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 接受处理意见
    endProcessing() {
      getendProcessing({ complaintsHeaderId: this.feedbackInfo.complaintsHeaderId }).then((res) => {
        if (res.code === 0) {
          this.$refs.table.refresh()
          this.$message.success(res.msg)
          this.dealingible = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 确定撤回
    deleteOK() {
      revoke({ complaintsHeaderId: this.feedbackInfo.complaintsHeaderId }).then((res) => {
        // console.log(res)
        if (res.code === 0) {
          this.deleteible = false
          this.$refs.table.refresh()
          this.dealingible = false
          this.$message.success(res.msg)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 撤回
    revoke() {
      this.deleteible = true
    },
    // 修改弹框确定
    updateproblem() {
      this.updateproblemform.validateFields((err, values) => {
        values.headerId = values.complaintsHeaderId
        const arr = []
        this.updatepiclist.forEach((tab) => {
          if (tab.response) {
            if (tab.response.code == 0) {
              const obj = {}
              obj.url = tab.response.url
              obj.uid = tab.uid
              obj.name = tab.name
              tab = obj
            }
          } else {
            tab.thumbUrl = ''
          }
          arr.push(JSON.stringify(tab))
          console.log(arr)
        })
        values.picUrlList = arr
        if (!err) {
          updateComplaint(values).then((res) => {
            // console.log(res)
            if (res.code === 0) {
              this.updateproblemible = false
              this.dealingible = false
              this.$refs.table.refresh()
              this.$message.success(res.msg)
              // this.interfaceReset(this.feedbackInfo.complaintsHeaderId)
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    // 修改
    updateFeedback() {
      const that = this
      this.updatepiclist = []
      this.updateproblemform.resetFields()
      setTimeout(() => {
        this.updateproblemform.setFieldsValue(
          pick(this.feedbackInfo, 'complaintsHeaderId', 'matterName', 'complainantName', 'handleStartTime')
        )
        this.updateproblemform.setFieldsValue(pick(this.feedbackInfo.itemInfos[0], 'contents'))
      }, 100)
      this.updatepiclist = this.feedbackInfo.itemInfos[0].arrList
      console.log(this.feedbackInfo)
      this.updateproblemible = true
    },

    // 履历
    resume(record) {
      console.log(record)
      getPendingMattersResume({ pendingMattersRecordId: record.complaintId, matterCode: record.matterCode }).then(
        (res) => {
          if (res.code === 0) {
            this.resumeible = true
            this.pendingMattersResume = res.data
          } else {
            this.$message.error(res.msg)
          }
        }
      )
    },
    // 转派确定
    addtransfer() {
      this.transferform.validateFields((err, values) => {
        console.log(values)
        if (!err) {
          transfer(values).then((res) => {
            if (res.code === 0) {
              this.$refs.table.refresh()
              this.$message.success(res.msg)
              this.transferible = false
              // this.dealingible=false
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    // 转派 表格
    problemsTransfer(record) {
      this.ransfertrecord = record
      console.log(record)
      this.transferform.resetFields()
      setTimeout(() => {
        this.transferform.setFieldsValue({
          complaintsHeaderId: record.complaintId,
        })
      }, 100)
      getPendingMattersRoleList().then((res) => {
        if (res.code === 0) {
          // console.log(res)
          this.pendingMattersRoleList = res.data
          this.transferible = true
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 处理
    problemsDealing(record) {
      this.dealingform.resetFields()
      this.replyproblemsform.setFieldsValue({
        contents: '',
      })

      this.dealinglist = []
      this.startProcessingible = false
      this.appealProcessingible = false
      this.processingCompletedible = false
      this.detailsViewible = false
      this.interfaceReset(record.complaintId)
      if (record.handleStatus == '处理中') {
        this.startProcessingible = true
        this.appealProcessingible = false
      } else if (record.handleStatus == '待确认') {
        this.startProcessingible = false
        this.processingCompletedible = true
      }
    },
    detailsView(record) {
      this.startProcessingible = false
      this.appealProcessingible = false
      this.processingCompletedible = false
      this.detailsViewible = true
      this.interfaceReset(record.complaintId)
    },

    // 市
    getselect(e) {
      getselectCityName({ provinceCode: e }).then((res) => {
        if (res.code === 0) {
          this.selectCityName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 区
    getprovinceName(e) {
      getselectAreaName({ cityCode: e }).then((res) => {
        if (res.code === 0) {
          console.log(res)
          this.selectAreaName = res.rows
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    onChangerangepicker(date, dateString) {
      this.queryParam.startTime = dateString[0]
      this.queryParam.endTime = dateString[1]
    },
    async installChange(e) {
      this.queryParam.orderType = ''
      this.List = []
      await getList(e).then((res) => {
        if (res.code === 0) {
          this.List = res.rows
          // console.log(res.rows)
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 将图片转换为Base64
    getImgToBase64(url, callback) {
      var canvas = document.createElement('canvas')
      var ctx = canvas.getContext('2d')
      var img = new Image()
      img.crossOrigin = 'Anonymous'
      img.onload = function () {
        canvas.height = img.height
        canvas.width = img.width
        ctx.drawImage(img, 0, 0)
        var dataURL = canvas.toDataURL('image/png')
        callback(dataURL)
        canvas = null
      }
      img.src = url
    },
  },
  watch: {
    $route(to, from) {
      this.$refs.table1.refresh()
    },
  },
}
</script>
<style scoped>
/deep/ .ant-table th {
  white-space: nowrap;
}
/deep/ .ant-table td {
  white-space: nowrap;
  padding: 6px 16px;
}
</style>
